<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider name="name" v-slot="{ errors }">
							<form-localized-input
								v-model="item.name"
								:errors="errors"
							>
							</form-localized-input>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="location_id"
							v-slot="{ errors }"
						>
							<v-autocomplete
								:items="locations"
								item-value="id"
								item-text="name"
								:label="$t('Location')"
								v-model="item.location_id"
								:error-messages="errors"
							>
							</v-autocomplete>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="phone" v-slot="{ errors }">
							<v-text-field
								v-model="item.phone"
								:label="$t('Phone')"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="email"
							rules="required|email"
							v-slot="{ errors }"
						>
							<v-text-field
								v-model="item.email"
								:label="$t('Email')"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider name="address" v-slot="{ errors }">
							<v-text-field
								v-model="item.address"
								:label="$t('Address')"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="review_link"
							v-slot="{ errors }"
						>
							<v-text-field
								v-model="item.review_link"
								:label="$t('label.review_link')"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="opening_time"
							v-slot="{ errors }"
						>
							<v-text-field
								v-model="item.settings.opening_time"
								:label="$t('Opening Time')"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<ValidationProvider
							name="description"
							v-slot="{ errors }"
						>
							<form-localized-editor
								v-model="item.description"
								:errors="errors"
							>
							</form-localized-editor>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="pl-10">
				<v-layout row wrap>
					<v-flex xs12>
						<v-card>
							<v-card-title primary-title>
								<h3>{{ $t("Cover Image") }}</h3>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<app-media-library
									v-model="item.image"
								></app-media-library>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="latitude"
							rules="required"
							v-slot="{ errors }"
						>
							<v-text-field
								v-model="item.latitude"
								:label="$t('Latitude')"
								:error-messages="errors"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md6>
						<ValidationProvider
							name="longitude"
							rules="required"
							v-slot="{ errors }"
						>
							<v-text-field
								v-model="item.longitude"
								:label="$t('Longitude')"
								:error-messages="errors"
								class="required"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12>
						<GmapMap
							:center="{ lat: latitude, lng: longitude }"
							:zoom="15"
							map-type-id="terrain"
							style="width: 100%; height: 400px"
							ref="mapRef"
						>
							<GmapMarker
								:position="{ lat: latitude, lng: longitude }"
								:clickable="true"
								:draggable="true"
								@click="
									center = { lat: latitude, lng: longitude }
								"
								@dragend="updatePosition"
							/>
						</GmapMap>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 v-if="item.settings">
				<v-card>
					<v-card-title primary-title>
						{{ $t("Setting") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.reservation_module"
									:label="$t('Reservation Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.delivery_module"
									:label="$t('Delivery Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.pickup_module"
									:label="$t('Pickup Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.dine_in_module"
									:label="$t('Dinein Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.review_module"
									:label="$t('Review Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.discover_module"
									:label="$t('Discover Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.map_module"
									:label="$t('Map Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.check_menu_module"
									:label="$t('Menu Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="
										item.settings
											.is_eligible_for_welcome_gift
									"
									:label="$t('Is Eligible for Welcome Gift')"
								></v-switch>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="team_webhook_url"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="item.settings.team_webhook_url"
										:label="
											$t(
												'Team Webhook URL for Reservation'
											)
										"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="team_webhook_url_for_order"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="
											item.settings
												.team_webhook_url_for_order
										"
										:label="
											$t('Team Webhook URL for Order')
										"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="team_webhook_url_for_membership"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="
											item.settings
												.team_webhook_url_for_membership
										"
										:label="
											$t(
												'Team Webhook URL for Membership'
											)
										"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<ValidationProvider
									name="team_webhook_url_for_wallet"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="
											item.settings
												.team_webhook_url_for_wallet
										"
										:label="
											$t('Team Webhook URL for Wallet')
										"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md6>
								<ValidationProvider
									name="facebook_url"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="item.settings.facebook_url"
										:label="$t('Facebook URL')"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md6>
								<ValidationProvider
									name="instagram_url"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="item.settings.instagram_url"
										:label="$t('Instagram URL')"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>

							<v-flex xs12 md6>
								<ValidationProvider
									name="max_adults"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="
											item.settings.reservation.max_adults
										"
										:label="
											$t(
												'Max Adults for Reservation Form'
											)
										"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12 md6>
								<ValidationProvider
									name="max_children"
									v-slot="{ errors }"
								>
									<v-text-field
										v-model="
											item.settings.reservation
												.max_children
										"
										:label="
											$t(
												'Max Children for Reservation Form'
											)
										"
										:error-messages="errors"
									></v-text-field>
								</ValidationProvider>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
				<p>&nbsp;</p>
				<v-card>
					<v-card-title primary-title>
						{{ $t("Reservation Email") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout wrap row>
							<v-flex xs12>
								<v-subheader>
									{{ $t("Reservation Email Header") }}
								</v-subheader>
								<ValidationProvider
									name="description"
									v-slot="{ errors }"
								>
									<form-localized-editor
										v-model="
											item.settings
												.reservation_email_header
										"
										:errors="errors"
									>
									</form-localized-editor>
								</ValidationProvider>
							</v-flex>
							<v-flex xs12>
								<v-subheader>
									{{ $t("Reservation Email Footer") }}
								</v-subheader>
								<ValidationProvider
									name="description"
									v-slot="{ errors }"
								>
									<form-localized-editor
										v-model="
											item.settings
												.reservation_email_footer
										"
										:errors="errors"
									>
									</form-localized-editor>
								</ValidationProvider>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value", "locations"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
		latitude() {
			return this.item.latitude ? this.item.latitude : 11.5564;
		},
		longitude() {
			return this.item.longitude ? this.item.longitude : 104.9282;
		},
	},
	methods: {
		updatePosition(e) {
			this.item.latitude = e.latLng.lat();
			this.item.longitude = e.latLng.lng();
			this.$refs.mapRef.$mapPromise.then((map) => {
				map.panTo({ lat: e.latLng.lat(), lng: e.latLng.lng() });
			});
		},
	},
};
</script>